import { render, staticRenderFns } from "./RequisitionSupportingDocuments.vue?vue&type=template&id=31095368&scoped=true"
import script from "./RequisitionSupportingDocuments.vue?vue&type=script&lang=js"
export * from "./RequisitionSupportingDocuments.vue?vue&type=script&lang=js"
import style0 from "./RequisitionSupportingDocuments.vue?vue&type=style&index=0&id=31095368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31095368",
  null
  
)

export default component.exports